import UsersIndex from '@/views/UsersIndex.vue';
import UsersEdit from '@/views/UsersEdit.vue';

const routes = [
    {
        path: '/users',
        name: 'UsersIndex',
        component: UsersIndex,
        meta: { layout: 'DashboardLayout' }
    },
    {
        path: '/users/:id',
        name: 'UsersEdit',
        component: UsersEdit,
        meta: { layout: 'DashboardLayout' }
    }
];

export default routes
